export enum StreamFileFormat {
  Csv = 'Csv',
  Tsv = 'Tsv',
  Json = 'Json',
  Xml = 'Xml',
  Xlsx = 'Xlsx',
}
